package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.domain.repository.SubscriptionWebhookEventRepository
import com.clany.backoffice.model.SubscriptionWebhookEventResponse
import io.ktor.client.request.parameter
import io.ktor.http.HttpMethod
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@ContributesBinding(AppScope::class)
@Inject
class SubscriptionWebhookEventRepositoryImpl(
    private val networkClient: NetworkClient
) : SubscriptionWebhookEventRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun getWebhookEvents(page: Int, pageSize: Int, query: String?): Result<List<SubscriptionWebhookEventResponse>> {
        return networkClient.request<List<SubscriptionWebhookEventResponse>>("$baseUrl/api/subscription-webhook-events") {
            parameter("page", page)
            parameter("limit", pageSize)
            if (query != null) parameter("q", query)
        }
    }

    override suspend fun getWebhookEventById(id: String): Result<SubscriptionWebhookEventResponse> {
        return networkClient.request<SubscriptionWebhookEventResponse>("$baseUrl/api/subscription-webhook-events/$id")
    }

    override suspend fun deleteWebhookEvent(id: String): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/subscription-webhook-events/$id", HttpMethod.Delete)
    }
}
